import {Component, QueryList, ViewChildren} from '@angular/core';
import {DateTime, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';
import {TAction, TFinanceView, TFinanceDate, TContaby, TFinanceSide} from "../../../app/enum";
import {HotspotService} from "../../../providers/hotspot-service";
import {ModalActionPage} from "../modal-action/modal-action";


@Component({
    selector: 'page-contaby-menu',
    templateUrl: 'contaby-menu.html',
    providers: [HotspotService]
})
export class ContabyMenuPage {

    @ViewChildren(DateTime) iondates: QueryList<DateTime>;

    TContaby: any = TContaby;
    TFinanceSide: any = TFinanceSide;
    TFinanceView: any = TFinanceView;

    config: any;

    rootcon: any;

    rootspot: any;
    copyspot: any;

    etapa: number;
    contaby: TContaby;

    financeSide: TFinanceSide;
    cashday: string;
    financeView: TFinanceView;
    financeDate: TFinanceDate = TFinanceDate.fdMes;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public hotspotService: HotspotService,
                public viewCtrl: ViewController, public util: Util) {


        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');
        this.contaby = this.navParams.get('contaby');

        this.financeSide = this.navParams.get('financeSide');
        this.financeView = this.navParams.get('financeView');
        this.cashday = this.navParams.get('cashday');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Contaby Menu', '/contaby-menu');

        this.contabyLoad();
    }

    getTitle() {

        if (this.etapa == 0) return 'Contábil'; //HOME
        if (this.etapa == 1) return 'Contábil'; //NF
        if (this.etapa == 2) return 'Contábil'; //DBP
        if (this.etapa == 3) return 'Contábil'; //DRE
        if (this.etapa == 4) return 'Contábil'; //DFC
        if (this.etapa == 5) return 'Contábil'; //CC

    }

    contabyLoad() {

        let hotspotID = this.rootspot.Hotspots[0].HotspotID;
      //let filtredID = (this.etapa == 4 ? this.filtred.AccountID : (!this.filtred ? 0 : this.filtred.FinanceFlag));

        let action = TAction.acLoad;
        if (this.etapa == 1) action = TAction.acNota;

        //Corrige Lastday Exemplo: vem 2021-02-31 troca para 2021-02-28
        //this.cashday = '2021-08-01';
        this.cashday = this.util.dateLast(this.cashday);

        this.hotspotService.contaby(action, hotspotID, 0, 0, this.financeSide, this.cashday, TFinanceDate.fdMes, null)
            .subscribe(
                data => this.rootcon = data,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    hotviewDate(flug: null | 'text' | 'done') {

        if (flug == 'done') {
            //this.rootcash = null;
            //this.financeDate = this.backupeDate;
            this.contabyLoad();
            return null;
        }

        if (flug == 'text') {
            if (this.financeDate == TFinanceDate.fdEra) return 'Período';
            let dia: null | 'dd' = (this.financeDate == TFinanceDate.fdDia ? 'dd' : null);
            let mes: null | 'char' = (this.financeDate != TFinanceDate.fdAno ? 'char' : null);
            return this.util.dataft(this.cashday, dia, mes, 'yyyy');
        }

        this.iondates.toArray()[0].open();

    }

    cashflow(info) {

        if (info) {
            let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'cashflow')};
            this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();
        }

        let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'flowcash')};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();


        //Push

    }

    dismiss() {

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss({}, 'back');
            return;
        }

        else this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/contaby-menu/contaby-menu.ts